import i18n from 'src/utils/translate';

import SearchTips from 'src/modules/search/shared/components/searchTips';
import { redirectToSearchPage } from 'src/utils/router';
import { SearchType } from 'src/constants/types';

type Props = {
  communitySlug?: string;
  isFiltered: boolean;
  isMemberOfCommunity?: boolean;
  query: string;
  searchType?: SearchType;
}
export default function EmptySearchResults({
  communitySlug,
  isFiltered,
  isMemberOfCommunity = false,
  query,
  searchType = 'posts',
}: Props) {
  const onClick = (e) => {
    e.preventDefault();
    redirectToSearchPage({ query });
  };


  let type = '';
  let postType = '';
  if (searchType === 'communities') {
    type = i18n.t('communities');
    postType = i18n.t('public') + ' ';
  } else if (searchType === 'members') {
    type = i18n.t('members');
  } else {
    type = i18n.t('posts');
    postType = !isMemberOfCommunity && i18n.t('public') + ' ';
  }

  let zeroResultsText = i18n.t(`Sorry, we don't have any public `) + type + i18n.t(' matching ');
  if (searchType === 'members') zeroResultsText = i18n.t(`Sorry, we don't have any members matching `);

  return (
    <div className="search__no-results" data-testid="search-no-results">
      <div className="no-results-summary">
        <div className="no-results-count">
          0 {postType}{type}
        </div>
        <div>
          { zeroResultsText }
          <span className="query-text">{query}</span>
        </div>
        {searchType !== 'members' && (
          isFiltered
            ? (
              <a href="#" onClick={onClick}>
                {i18n.t('Search posts on all of HealthUnlocked')}
              </a>
            ) : <div>{i18n.t('Try broadening your search to get more results')}</div>
        )}
      </div>
      <SearchTips
        communitySlug={communitySlug}
        isMemberOfCommunity={isMemberOfCommunity}
        searchType={searchType}
      />
    </div>
  );
}

